import { render } from "./AccountView.vue?vue&type=template&id=3fbd3bc4&scoped=true&ts=true"
import script from "./AccountView.vue?vue&type=script&lang=ts"
export * from "./AccountView.vue?vue&type=script&lang=ts"

import "./AccountView.vue?vue&type=style&index=0&id=3fbd3bc4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbd3bc4"]])

export default __exports__